module.exports = __webpack_public_path__ + "img/xingyaya.0b919aad.jpg";